export default "__VITE_ASSET__4d5eefa0__"